var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4998 2.4165C7.854 2.4165 2.4165 7.854 2.4165 14.4998C2.4165 21.1457 7.854 26.5832 14.4998 26.5832C21.1457 26.5832 26.5832 21.1457 26.5832 14.4998C26.5832 7.854 21.1457 2.4165 14.4998 2.4165ZM12.7903 19.8344C12.3998 20.2249 11.7666 20.2249 11.3761 19.8344L6.74861 15.2069C6.35809 14.8164 6.35809 14.1833 6.74861 13.7927L7.03913 13.5022C7.42927 13.1121 8.06168 13.1116 8.45236 13.5012L11.3761 16.4168C11.7667 16.8064 12.3992 16.8059 12.7893 16.4158L20.5448 8.66028C20.9363 8.26878 21.5714 8.2699 21.9615 8.66278L22.2561 8.95941C22.6442 9.35033 22.6431 9.98157 22.2536 10.3711L12.7903 19.8344Z",
    fill: "#6B51EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallCheckmark);
export default __webpack_public_path__ + "static/media/small-checkmark.68accf2d380e867810e165137bd243a9.svg";
export { ForwardRef as ReactComponent };